export const PRIMARY_SERVER_URL = process.env.REACT_APP_PRIMARY_SERVER_URL;
let activeServerURL = PRIMARY_SERVER_URL;

/************************************************************************/
async function connectToAPI(tcontextURL, tmethod, data) {
  try {
    const response = await fetch(activeServerURL + tcontextURL, {
      method: tmethod ? tmethod : "GET",
      headers: {
        "Content-Type": "application/json",
      },
      body: data ? JSON.stringify(data) : null,
    });

    console.log("API Response Status:", response.status);
    
    if (response.status === 401) {
      return "false";
    }
    return response;
  } catch (error) {
    console.log('Error connecting to API:', error);
    console.log('Both primary servers are down.');
    activeServerURL = PRIMARY_SERVER_URL;
    return "false";
  }
}

/**************Competition Group APIs ***************/
export async function createCompetitionGroup(organizerId, groupData) {
  try {
    // Ensure proper data structure
    const payload = {
      name: groupData.name || `Group ${new Date().toLocaleTimeString()}`,
      organizerId: organizerId,
      competitionIds: Array.isArray(groupData.competitionIds)
        ? groupData.competitionIds.filter(id => id && id.trim() !== '')
        : [],
      countdownDuration: groupData.countdownDuration || 10
    };

    console.log('Creating competition group with payload:', payload);

    // FIXED: Call connectToAPI with correct parameters
    return await connectToAPI('/api/competition-groups', "POST", payload);
  } catch (error) {
    console.error('Error creating competition group:', error);
    throw error;
  }
}

export async function getCompetitionGroups(organizerId) {
  try {
    if (!organizerId || organizerId.trim() === '') {
      throw new Error('Organizer ID is required');
    }

    return await connectToAPI(`/api/competition-groups/organizer/${organizerId}`);
  } catch (error) {
    console.error('Error fetching competition groups:', error);
    throw error;
  }
}

export async function deleteCompetitionGroup(groupId) {
  return await connectToAPI(`/api/competition-groups/${groupId}`, "DELETE");
}

/**************Competition APIs ***************/
export async function getCompetitionByOrganiser(bid) {
  return await connectToAPI(`/api/competitions/${bid}`);
}

export async function getCompetitionsWithTimer(bid) {
  return await connectToAPI(`/api/competitions/competitionstime/${bid}`);
}

export async function getCompetitionById(bid) {
  return await connectToAPI(`/api/competitions/detail/${bid}`);
}

export async function CreateCompetition(id, data) {
  return await connectToAPI(`/api/competitions/${id}`, "POST", data);
}

export async function deleteCompetitions(id, competitionid) {
  return await connectToAPI(`/api/competitions/${id}?competitionid=${competitionid}`, "DELETE");
}

/**************Judge APIs ***************/
export async function createJudge(id, data) {
  return await connectToAPI(`/api/competitions/judge/${id}`, "POST", data);
}

export async function getJudges(id) {
  return await connectToAPI(`/api/competitions/judge/${id}`);
}

export async function deleteJudge(id, judgeid) {
  return await connectToAPI(`/api/competitions/judge/${id}?judgeid=${judgeid}`, "DELETE");
}

export async function createMultipleJudges(id, data) {
  return await connectToAPI(`/api/competitions/bulkjudges/${id}`, "POST", data);
}

/**************Climber APIs ***************/
export async function createClimber(id, data) {
  return await connectToAPI(`/api/competitions/climber/${id}`, "POST", data);
}

export async function getClimber(id) {
  return await connectToAPI(`/api/competitions/climber/${id}`);
}

export async function deleteClimber(id, judgeid) {
  return await connectToAPI(`/api/competitions/judge/${id}?judgeid=${judgeid}`, "DELETE");
}

export async function createMultipleClimbers(id, data) {
  return await connectToAPI(`/api/competitions/bulkclimbers/${id}`, "POST", data);
}

/**************User APIs ***************/
export async function NumberVerify(data) {
  return await connectToAPI(`/api/users/numberverify`, "POST", data);
}

/************************************************************************/
// Timer Control APIs - UPDATED FOR ROUND-ROBIN SYSTEM
/************************************************************************/

export const createTimer = async (competitionId, data = {}) => {
  return await connectToAPI(`/api/timer/${competitionId}/create`, "POST", data);
};

export const startCountdown = async (competitionId) => {
  return await connectToAPI(`/api/timer/${competitionId}/start-countdown`, "POST");
};

export const startClimbing = async (competitionId) => {
  return await connectToAPI(`/api/timer/${competitionId}/start-climbing`, "POST");
};

export const startWrapTime = async (competitionId) => {
  return await connectToAPI(`/api/timer/${competitionId}/start-wrap-time`, "POST");
};

export const pauseTimer = async (competitionId, reason = "Manual pause", pausedBy = null) => {
  return await connectToAPI(`/api/timer/${competitionId}/pause`, "POST", {
    reason,
    pausedBy
  });
};

export const resumeTimer = async (competitionId) => {
  return await connectToAPI(`/api/timer/${competitionId}/resume`, "POST");
};

export const resetTimer = async (competitionId) => {
  return await connectToAPI(`/api/timer/${competitionId}/reset`, "POST");
};

export const getTimerState = async (competitionId) => {
  return await connectToAPI(`/api/timer/${competitionId}/state`);
};

export const getTimerStatistics = async (competitionId) => {
  return await connectToAPI(`/api/timer/${competitionId}/statistics`);
};

export const getClimbByCompetition = async (cid) => {
  return await connectToAPI(`/api/climbs/competition/${cid}`);
}

export const UpdateClimb = async (cid, update) => {
  return await connectToAPI(`/api/climbs`, "POST", update);
}

// Add this helper function to check if response is valid
export const isResponseValid = (response) => {
  return response && response !== "false" && response.ok;
};

// Add this function to handle API errors consistently
export const handleApiError = (error, defaultMessage = "API Error") => {
  console.error(defaultMessage, error);
  if (error.response) {
    // The request was made and the server responded with a status code
    console.error("Response data:", error.response.data);
    console.error("Response status:", error.response.status);
    console.error("Response headers:", error.response.headers);
    return {
      success: false,
      message: error.response.data?.message || defaultMessage,
      status: error.response.status
    };
  } else if (error.request) {
    // The request was made but no response was received
    console.error("No response received:", error.request);
    return {
      success: false,
      message: "No response from server. Please check your connection.",
      status: 0
    };
  } else {
    // Something happened in setting up the request
    console.error("Request setup error:", error.message);
    return {
      success: false,
      message: error.message || defaultMessage,
      status: null
    };
  }
};